import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios";
import qs from "qs";
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';import SessionStorage from 'quasar/src/plugins/SessionStorage.js';;

var TCAP =
/*#__PURE__*/
function () {
  function TCAP() {
    _classCallCheck(this, TCAP);
  }

  _createClass(TCAP, null, [{
    key: "GetTCAPCategories",
    value: function GetTCAPCategories(projectId, doNotShowLoading) {
      if (doNotShowLoading) return axios.get("/api/TCAP/GetBudgetCategories/".concat(projectId), {
        doNotShowLoading: doNotShowLoading ? true : false
      });else return axios.get("/api/TCAP/GetBudgetCategories/".concat(projectId));
    }
  }, {
    key: "CreateBudget",
    value: function CreateBudget(budgetTimeFrame) {
      return axios.post("/api/TCAP/CreateBudget", budgetTimeFrame);
    }
  }, {
    key: "CreateProjectBudget",
    value: function CreateProjectBudget(budgetTimeFrame) {
      return axios.post("/api/TCAP/CreateProjectBudget", budgetTimeFrame);
    }
  }, {
    key: "TempAdminList",
    value: function TempAdminList() {
      return axios.get("/api/TCAP/TempAdminList");
    }
  }, {
    key: "UpdateTCAP",
    value: function UpdateTCAP(tcap) {
      return axios.patch("/api/TCAP/UpdateTCAP", tcap);
    }
  }, {
    key: "UpdateTCAPQuarterStatus",
    value: function UpdateTCAPQuarterStatus(tcap) {
      return axios.patch("/api/TCAP/UpdateTCAPQuarterStatus", tcap);
    }
  }, {
    key: "UpdateTCAPStatus",
    value: function UpdateTCAPStatus(tcap) {
      return axios.patch("/api/TCAP/UpdateTCAPStatus", tcap);
    }
  }, {
    key: "CreateBudgetCategoryAmount",
    value: function CreateBudgetCategoryAmount(categoryAmount) {
      return axios.post("/api/TCAP/CreateBudgetCategoryAmount", categoryAmount);
    }
  }, {
    key: "UpdateBudgetCategoryAmount",
    value: function UpdateBudgetCategoryAmount(categoryAmount) {
      return axios.patch("/api/TCAP/UpdateBudgetCategoryAmount", categoryAmount);
    }
  }, {
    key: "GetTCAPByProjectId",
    value: function GetTCAPByProjectId(projectId) {
      return axios.get("/api/TCAP/GetTCAPByProjectId/".concat(projectId));
    }
  }, {
    key: "GetBudgetByBudgetId",
    value: function GetBudgetByBudgetId(budgetId) {
      return axios.get("/api/TCAP/GetBudgetByBudgetId/".concat(budgetId));
    }
  }, {
    key: "GetStatementQuery",
    value: function GetStatementQuery(propertyId, statmentType, budgetYear) {
      return axios.get("/api/TCAP/GetStatementQuery/".concat(propertyId, "/").concat(statmentType, "/").concat(budgetYear));
    }
  }, {
    key: "GetAllTCAP",
    value: function GetAllTCAP(year, statusId, quarter) {
      return axios.get("/api/TCAP/GetAllTCAP", {
        params: {
          year: year,
          statusId: statusId,
          quarter: quarter
        }
      });
    }
  }, {
    key: "GetTCAPsByQuarter",
    value: function GetTCAPsByQuarter(projectId, year, quarter) {
      return axios.get("/api/TCAP/GetTCAPsByQuarter", {
        params: {
          year: year,
          projectId: projectId,
          quarter: quarter
        }
      });
    }
  }, {
    key: "DeleteStatementCategoryBreakdown",
    value: function DeleteStatementCategoryBreakdown(statementCategoryBreakdownId, statementCategoryAmountId) {
      return axios.delete("/api/TCAP/DeleteStatementCategoryBreakdown", {
        params: {
          statementCategoryBreakdownId: statementCategoryBreakdownId,
          statementCategoryAmountId: statementCategoryAmountId
        }
      });
    }
  }, {
    key: "GetBudgetCountByKeyLetter",
    value: function GetBudgetCountByKeyLetter(key, selectFilter, subFilter) {
      return axios.get("/api/TCAP/GetBudgetCountByKeyLetter", {
        params: {
          key: key,
          statusId: selectFilter,
          budgetYear: subFilter
        }
      });
    }
  }, {
    key: "GetTCAPQuarter",
    value: function GetTCAPQuarter(projectId, year, quarter, month) {
      return axios.get("/api/TCAP/GetTCAPQuarter/".concat(projectId, "/").concat(year, "/").concat(quarter, "/").concat(month));
    }
  }, {
    key: "GetAllTCAPCount",
    value: function GetAllTCAPCount() {
      return axios.get("/api/TCAP/GetAllTCAPCount");
    }
  }, {
    key: "GetYearAndQuarterRange",
    value: function GetYearAndQuarterRange() {
      return axios.get("/api/TCAP/GetYearRange");
    }
  }, {
    key: "GetProjectBudgetById",
    value: function GetProjectBudgetById(budgetId) {
      return axios.get("/api/TCAP/GetProjectBudgetById/".concat(budgetId));
    }
  }, {
    key: "GetProjectDetails",
    value: function GetProjectDetails(projectId) {
      return axios.get("/api/TCAP/GetProjectDetails/".concat(projectId));
    }
  }, {
    key: "CreateCertification",
    value: function CreateCertification(userId) {
      return axios.post("/api/TCAP/CreateCertification", {
        UserId: userId,
        Date: new Date()
      });
    }
  }, {
    key: "GetLastSavedBudget",
    value: function GetLastSavedBudget() {
      return axios.get("/api/TCAP/GetLastSavedBudget");
    }
  }, {
    key: "CreateStatementCategoryBreakdown",
    value: function CreateStatementCategoryBreakdown(statementCategoryBreakdown) {
      return axios.post("/api/TCAP/CreateStatementCategoryBreakdown", statementCategoryBreakdown);
    }
  }, {
    key: "CreateStatementCategoryAmountBreakdown",
    value: function CreateStatementCategoryAmountBreakdown(statementBreakdownAmount) {
      return axios.post("/api/TCAP/CreateStatementCategoryAmountBreakdown", statementBreakdownAmount);
    }
  }, {
    key: "UpdateStatmentDates",
    value: function UpdateStatmentDates(statement) {
      return axios.patch("/api/TCAP/UpdateStatementDates", statement);
    }
  }, {
    key: "UploadAttachment",
    value: function UploadAttachment(files, tcapId) {
      var formData = new FormData();
      files.forEach(function (file) {
        formData.append("files[]", file);
      });
      formData.append("requestId", tcapId);
      return axios.post("api/TCAP/AddAttachments/".concat(tcapId), formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    }
  }, {
    key: "GetFiles",
    value: function GetFiles(tcapId) {
      return axios.get("/api/TCAP/GetFiles/".concat(tcapId));
    }
  }]);

  return TCAP;
}();

export { TCAP as default };